module.exports = __webpack_public_path__ + "static/fonts/SCDream6.9c7a81c.otf";